import { useState } from "react";
import { ResultOf } from "gql.tada";
import { HeroById } from "@queries/entries/HeroById";
import PlayIcon from "@hawkins/assets/lib/icons/iconPlay";
import * as Dialog from "@radix-ui/react-dialog";
import { Button } from "@components/shared/core/Button";
import FullVideoPlayer from "@components/shared/FullVideoPlayer";
import { useIsDesktop } from "@hooks/useIsDesktop";
import { DynamicScaling } from "@components/shared/DynamicScaling";
import { MarkdownLite } from "@components/shared/MarkdownLite";

export const VideoWIthCopyAndCtaHero = ({
  entry: { hero: entry },
}: {
  entry: ResultOf<typeof HeroById>;
}) => {
  const isDesktop = useIsDesktop();

  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!entry) return null;

  const onOpenChange = (isOpen: boolean) => {
    if (isDesktop) {
      setIsModalOpen(isOpen);
    }
  };

  return (
    <Dialog.Root open={isModalOpen} onOpenChange={onOpenChange}>
      <div className="w-full min-h-screen flex flex-col justify-center items-center pb-10 px-12 relative">
        {!!entry?.previewVideo?.url && (
          <video
            autoPlay
            loop
            playsInline
            muted
            src={entry.previewVideo.url}
            className="absolute inset-0 size-full object-cover brightness-60"
          />
        )}
        <div className="z-10 flex flex-col items-center justify-center mt-[calc(50vh-76px)] dsk:mt-[calc(50vh-136px)] gap-9 max-w-screen">
          <DynamicScaling>
            <h1 className="text-heading-1 dsk:text-[200px] uppercase">
              {entry.title}
            </h1>
          </DynamicScaling>
          {!!entry?.fullVideo?.url && (
            <>
              {isDesktop ? (
                <Dialog.Trigger>
                  <Button asChild variant="light-on-blur">
                    <span className="flex flex-row gap-2 items-center">
                      <PlayIcon size="small" />
                      {entry.ctaText}
                    </span>
                  </Button>
                </Dialog.Trigger>
              ) : (
                <Button asChild variant="light-on-blur">
                  {/* eslint-disable-next-line react/forbid-elements */}
                  <a
                    className="flex flex-row gap-2 items-center"
                    href={entry.fullVideo.url}
                  >
                    <PlayIcon size="small" />
                    {entry.ctaText}
                  </a>
                </Button>
              )}
            </>
          )}
        </div>
        <div className="z-10 flex flex-col items-center justify-end grow">
          <p className="text-body-regular text-center max-w-[450px] text-brand-cream">
            <MarkdownLite>{entry.description}</MarkdownLite>
          </p>
        </div>
        {!!entry?.fullVideo?.url && (
          <FullVideoPlayer
            isOpen={isModalOpen}
            videoUrl={entry.fullVideo.url}
            setIsOpen={setIsModalOpen}
          />
        )}
      </div>
    </Dialog.Root>
  );
};
